// Dummy data for NEXUS BIN dashboard
// Threat levels
export const nationalThreatLevel = 'moderate' as const
export const lastUpdated = '2 minutes ago'
// Top priority alerts
export const priorityAlerts = [
  {
    id: 'RPT001',
    title: 'Potensi Demonstrasi Massal di Jakarta',
    location: 'Jakarta Pusat',
    riskLevel: 'high' as const,
    category: 'Politik',
    deputy: 'Deputi II',
    bindaRegion: 'BINDA DKI Jakarta',
    status: 'ongoing' as const,
  },
  {
    id: 'RPT002',
    title: 'Aktivitas Separatis di Perbatasan Papua',
    location: 'Jayapura',
    riskLevel: 'critical' as const,
    category: 'Pertahanan Keamanan',
    deputy: 'Deputi VI',
    bindaRegion: 'BINDA Papua',
    status: 'ongoing' as const,
  },
  {
    id: 'RPT003',
    title: 'Serangan Siber Infrastruktur Kritis',
    location: 'Jakarta',
    riskLevel: 'critical' as const,
    category: 'Pertahanan Keamanan',
    deputy: 'Deputi IX',
    bindaRegion: 'BINDA DKI Jakarta',
    status: 'ongoing' as const,
  },
  {
    id: 'RPT004',
    title: 'Penyebaran Disinformasi Pemilu',
    location: 'Surabaya',
    riskLevel: 'moderate' as const,
    category: 'Politik',
    deputy: 'Deputi III',
    bindaRegion: 'BINDA Jawa Timur',
    status: 'monitoring' as const,
  },
  {
    id: 'RPT005',
    title: 'Radikalisasi Ideologi di Kampus',
    location: 'Bandung',
    riskLevel: 'moderate' as const,
    category: 'Ideologi',
    deputy: 'Deputi V',
    bindaRegion: 'BINDA Jawa Barat',
    status: 'monitoring' as const,
  },
  {
    id: 'RPT006',
    title: 'Fluktuasi Ekonomi Ekstrem Kalimantan',
    location: 'Balikpapan',
    riskLevel: 'high' as const,
    category: 'Ekonomi',
    deputy: 'Deputi VII',
    bindaRegion: 'BINDA Kalimantan Timur',
    status: 'monitoring' as const,
  },
  {
    id: 'RPT007',
    title: 'Konflik Sosial Antar Etnis Maluku',
    location: 'Ambon',
    riskLevel: 'high' as const,
    category: 'Sosial Budaya',
    deputy: 'Deputi IV',
    bindaRegion: 'BINDA Maluku',
    status: 'ongoing' as const,
  },
  {
    id: 'RPT008',
    title: 'Illegal Mining Kalimantan Barat',
    location: 'Pontianak',
    riskLevel: 'moderate' as const,
    category: 'Ekonomi',
    deputy: 'Deputi VII',
    bindaRegion: 'BINDA Kalimantan Barat',
    status: 'monitoring' as const,
  },
]
// iBRIEF snapshot
export const briefSnapshot = [
  'Peningkatan 27% aktivitas mencurigakan di perbatasan timur dalam 72 jam terakhir',
  'Deteksi 5 narasi disinformasi baru terkait ekonomi nasional yang viral di media sosial',
  'Kontak diplomatik dengan negara X menunjukkan perubahan sikap signifikan',
  'Monitoring ketat terhadap kelompok radikal di 3 provinsi menunjukkan aktivitas meningkat',
  'Analisis pasar menunjukkan fluktuasi tidak wajar pada sektor pertambangan',
]
// Performance metrics
export const performanceMetrics = {
  responseRate: 87,
  intelligenceProducts: 142,
  areaCoverage: 94,
}
// All Deputies list
export const allDeputies = [
  'Deputi I - Administrasi',
  'Deputi II - Politik & Keamanan',
  'Deputi III - Intelijen Luar Negeri',
  'Deputi IV - Sosial Budaya',
  'Deputi V - Ideologi & Terorisme',
  'Deputi VI - Pertahanan & Keamanan',
  'Deputi VII - Ekonomi',
  'Deputi VIII - Teknologi & Informasi',
  'Deputi IX - Siber',
]
// Deputy performance data
export const deputyPerformance = [
  {
    unit: 'Deputi I - Administrasi',
    reportVolume: 28,
    quality: 88,
    onTime: 85,
    status: 'good' as const,
  },
  {
    unit: 'Deputi II - Politik & Keamanan',
    reportVolume: 45,
    quality: 92,
    onTime: 88,
    status: 'good' as const,
  },
  {
    unit: 'Deputi III - Intelijen Luar Negeri',
    reportVolume: 38,
    quality: 89,
    onTime: 85,
    status: 'good' as const,
  },
  {
    unit: 'Deputi IV - Sosial Budaya',
    reportVolume: 32,
    quality: 85,
    onTime: 82,
    status: 'good' as const,
  },
  {
    unit: 'Deputi V - Ideologi & Terorisme',
    reportVolume: 42,
    quality: 90,
    onTime: 86,
    status: 'good' as const,
  },
  {
    unit: 'Deputi VI - Pertahanan & Keamanan',
    reportVolume: 40,
    quality: 91,
    onTime: 87,
    status: 'good' as const,
  },
  {
    unit: 'Deputi VII - Ekonomi',
    reportVolume: 35,
    quality: 86,
    onTime: 83,
    status: 'good' as const,
  },
  {
    unit: 'Deputi VIII - Teknologi & Informasi',
    reportVolume: 30,
    quality: 87,
    onTime: 84,
    status: 'good' as const,
  },
  {
    unit: 'Deputi IX - Siber',
    reportVolume: 48,
    quality: 93,
    onTime: 90,
    status: 'good' as const,
  },
  {
    unit: 'BINDA DKI Jakarta',
    reportVolume: 28,
    quality: 88,
    onTime: 84,
    status: 'good' as const,
  },
  {
    unit: 'BINDA Jawa Barat',
    reportVolume: 25,
    quality: 84,
    onTime: 80,
    status: 'good' as const,
  },
  {
    unit: 'BINDA Jawa Timur',
    reportVolume: 27,
    quality: 86,
    onTime: 82,
    status: 'good' as const,
  },
  {
    unit: 'BINDA Papua',
    reportVolume: 22,
    quality: 82,
    onTime: 78,
    status: 'attention' as const,
  },
  {
    unit: 'BINDA Kalimantan Timur',
    reportVolume: 20,
    quality: 80,
    onTime: 75,
    status: 'attention' as const,
  },
]
